import { db } from "../services/firebase";
import { collection, addDoc, query, where, orderBy, getDocs, serverTimestamp } from "firebase/firestore";

// Add a calendar event to Firestore
export async function addCalendarEvent({ listingId, buyerId, sellerId, date, time, location, title }) {
  const { auth } = await import('../services/firebase');
  const currentUser = auth.currentUser;
  
  if (!currentUser) {
    throw new Error('User must be authenticated to create calendar events');
  }
  
  const eventData = {
    listingId,
    buyerId,
    sellerId,
    date,
    time,
    location,
    title,
    status: "accepted",
    createdBy: currentUser.uid, // Required by Firestore rules
    participants: [buyerId, sellerId], // Add participants array for update permissions
    createdAt: serverTimestamp(),
  };
  
  const ref = await addDoc(collection(db, "calendarEvents"), eventData);
  
  return ref.id;
}

// Fetch calendar events for a user
export async function fetchUserCalendarEvents(userId) {
  // Firestore does not support $or queries, so run two queries and merge
  const buyerQ = query(
    collection(db, "calendarEvents"),
    where("buyerId", "==", userId),
    orderBy("createdAt", "desc")
  );
  const sellerQ = query(
    collection(db, "calendarEvents"),
    where("sellerId", "==", userId),
    orderBy("createdAt", "desc")
  );
  
  const [buyerSnap, sellerSnap] = await Promise.all([getDocs(buyerQ), getDocs(sellerQ)]);
  
  const events = [
    ...buyerSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })),
    ...sellerSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
  ];
  
  // Remove duplicates (if any)
  const uniqueEvents = Object.values(events.reduce((acc, ev) => {
    acc[ev.id] = ev;
    return acc;
  }, {}));
  
  return uniqueEvents;
}
